import { useState } from "react";
import ChevronIcon from "../../img/chevronIcon";

/**
 * Acordeão do admin (página do cliente / pedido).
 * Chevron no topo à direita; `defaultOpen` inicia expandido.
 */
const Accordion = ({ title, children, defaultOpen = false }) => {
    const [show, setShow] = useState(Boolean(defaultOpen));

    return (
        <div
            className="border border-primary relative"
            style={{ backgroundColor: show ? "#000" : "transparent" }}
            data-testid="admin-accordion"
            data-open={show ? "true" : "false"}
        >
            <button
                type="button"
                className="relative w-full cursor-pointer bg-transparent py-3 pr-12 text-center"
                onClick={() => setShow(!show)}
                aria-expanded={show}
                title={show ? "Recolher" : "Expandir"}
            >
                <span className={`text-primary ${show ? "text-lg font-medium" : ""}`}>
                    {title}
                </span>
                <span
                    className={`pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 ${show ? "rotate-180" : ""}`}
                    aria-hidden="true"
                >
                    <ChevronIcon width="32px" fill="#d59106" />
                </span>
            </button>
            {show ? (
                <div className="border-t border-primary/40 bg-black px-3 pb-4 pt-3">
                    {children}
                </div>
            ) : null}
        </div>
    );
};

export default Accordion;
